import React, { forwardRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

import { cn } from '../../tailwind';
import { Analytics } from '../../utils';
import { PAGE_VIEW } from '../../utils/legacy-analytics/eventTypes';

const Page = forwardRef(
  (
    {
      children,
      title,
      className,
    }: { children: React.ReactNode; title?: string; className?: string },
    ref,
  ) => {
    const { pathname } = useLocation();
    useEffect(() => {
      Analytics.track(PAGE_VIEW, { pathname });
    }, []);

    return (
      <div
        ref={ref as React.RefObject<HTMLDivElement>}
        className={cn('container py-10 h-auto', className)}
      >
        <Helmet>
          <title>
            {title ? `autone.io | ${title.toLowerCase()}` : 'autone.io'}
          </title>
        </Helmet>
        {children}
      </div>
    );
  },
);

export default Page;
